import {
  copydc,
  copyowner,
  exportApi,
  importApi,
  query,
  queryAllMenus,
  sendQuest,
} from '@/services/down/apidocs';

export default {
  namespace: 'apidocs',
  state: {
    data: [],
    selectKey: '1',
  },

  effects: {
    *query({ payload, callback }, { call, put }) {
      const response = yield call(query, payload);
      if (response.success) {
        yield put({
          type: 'success',
          payload: {
            data: response.data,
          },
        });
      }
      if (callback) callback(response);
    },
    *queryAllMenus({ payload, callback }, { call, put }) {
      const response = yield call(queryAllMenus, payload);
      if (callback) callback(response);
    },
    *send({ payload, callback }, { call, put }) {
      const response = yield call(sendQuest, payload);
      yield put({
        type: 'sendSuccess',
        payload: {
          result: response,
        },
      });
    },
    *copydc({ payload, callback }, { call, put }) {
      const response = yield call(copydc, payload);
      if (callback) callback(response);
    },
    *copyowner({ payload, callback }, { call, put }) {
      const response = yield call(copyowner, payload);
      if (callback) callback(response);
    },
    *exportApi({ payload, callback }, { call, put }) {
      const response = yield call(exportApi, payload);
      if (callback) callback(response);
    },
    *importApi({ payload, callback }, { call, put }) {
      const response = yield call(importApi, payload);
      if (callback) callback(response);
    },
    *onClearResponse({ payload, callback }, { call, put }) {
      yield put({
        type: 'clearResponse',
      });
    },

    *showLogPage({ payload }, { call, put }) {
      yield put({
        type: 'onShowLogPage',
        payload: {
          serviceName: payload.serviceName,
          selectKey: '2',
        },
      });
    },

    *showCreatePage({ payload }, { call, put }) {
      yield put({
        type: 'onShowCreatePage',
      });
    },
  },

  reducers: {
    success(state, { payload }) {
      return {
        ...state,
        data: payload.data,
        responseResult: payload.result,
        createModalVisible: false,
      };
    },
    sendSuccess(state, { payload }) {
      return {
        ...state,
        responseResult: payload.result,
        selectKey: '4',
        createModalVisible: false,
      };
    },
    clearResponse(state, { payload }) {
      return {
        ...state,
        responseResult: {},
        createModalVisible: false,
      };
    },
    onShowLogPage(state, { payload }) {
      return {
        ...state,
        selectKey: '2',
        serviceName: payload.serviceName,
        createModalVisible: false,
      };
    },
    onShowCreatePage(state, { payload }) {
      return {
        ...state,
        createModalVisible: true,
      };
    },
  },

  subscriptions: {
    setup({ dispatch, history }) {
      return history.listen(({ pathname }) => {
        if (pathname === '/') {
          dispatch({
            type: 'query',
          });
        }
      });
    },
  },
};
